import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {db} from './firebase/firebase';

import { compose } from 'recompose';
import {withAuthorization} from './utils/auth';
import { Form, Tag, Card, Input, Button, Icon, Spin, notification, Divider, Alert} from 'antd';
import {NavLink, withRouter} from 'react-router-dom';
import marked from 'marked';

var ReactMarkdown = require('react-markdown');

const FormItem = Form.Item;
const { TextArea } = Input;
@observer
class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zipCodeField: null,
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  zips;
  async deleteTag(e) {
    console.log('delete:', e);
    try {
      await e.delete();
    } catch (e) {
      console.log('Error', e.message);
      notification.error({
        message: "Impossible d'éffectuer l'opération",
        description: e.message
      })
      return false;
    }
    notification.success({
      message: "Opération réussie"
    })
  }
  async handleSubmit(e, things) {
    e.preventDefault();
    if(this.state.zipCodeField !== '' && this.state.zipCodeField !== null && this.state.zipCodeField !== ' '){
      const exists = this.props.userStore.zip.docs.filter((tag, i) => {if(tag.data.value === this.state.zipCodeField) return tag});
      console.log("exists?", exists, exists.length);
      if(exists.length === 0) {
        this.setState({loading: true});
        try {
          await this.props.userStore.zip.add({value: this.state.zipCodeField});
        } catch (e) {
          console.log('Error', e.message);
          notification.error({
            message: "Impossible d'éffectuer l'opération",
            description: e.message
          })
          return false;
        }
        notification.success({
          message: "Opération réussie"
        })
        this.setState({loading: false});
        this.setState({zipCodeField: null});
      } else {
        this.setState({zipCodeField: null});
      }
    }
  }

  componentDidMount() {
    this.setState({nurseFAQloading: true});
    this.setState({patientFAQloading: true});
    this.setState({CGUloading: true});

    db.collection("config").doc("NURSEFAQ").get().then((querySnapshot) => {
      if(querySnapshot.exists){

        this.setState({ nursefaq: querySnapshot });
        this.setState({ nursefaqField: querySnapshot.data().markdown });
        this.setState({nurseFAQloading: false});
      } else {
        this.setState({nurseFAQloading: false});
      }
    });
    db.collection("config").doc("PATIENTFAQ").get().then((querySnapshot) => {
      if(querySnapshot.exists){

        this.setState({ patientfaq: querySnapshot });
        this.setState({ patientfaqField: querySnapshot.data().markdown });
        this.setState({patientFAQloading: false});
      } else {
        this.setState({patientFAQloading: false});
      }
    });

    db.collection("config").doc("CGU").get().then((querySnapshot) => {
      if(querySnapshot.exists){
        this.setState({ cgu: querySnapshot });
        this.setState({ cguField: querySnapshot.data().markdown });

        this.setState({CGUloading: false});
      } else {
        this.setState({CGUloading: false});
      }
    });

  }
  async updateNurseFAQ(e) {
    e.preventDefault();
    console.log('FAQ: ', this.state.nursefaqField);
    this.setState({nurseFAQloading: true});
    return db.collection('config').doc("NURSEFAQ").set({
      markdown: this.state.nursefaqField
    }, {merge: true}).then(() => {
      this.setState({nurseFAQloading: false});
      notification.success({
        message: "Opération réussie"
      })
    })
    .catch((e) => {
      console.error("Error", e);
      notification.error({
        message: "Impossible d'éffectuer l'opération",
        description: e.message
      })
    })
  }

  async updatePatientFAQ(e) {
    e.preventDefault();
    console.log('FAQ: ', this.state.patientfaqField);
    this.setState({patientFAQloading: true});
    return db.collection('config').doc("PATIENTFAQ").set({
      markdown: this.state.patientfaqField
    }, {merge: true}).then(() => {
      this.setState({patientFAQloading: false});
      notification.success({
        message: "Opération réussie"
      })
    })
    .catch((e) => {
      console.error("Error", e);
      notification.error({
        message: "Impossible d'éffectuer l'opération",
        description: e.message
      })
    })
  }
  async updateCGU(e) {
    e.preventDefault();
    console.log('CGU: ', this.state.cguField);
    this.setState({CGUloading: true});
    return db.collection('config').doc("CGU").set({
      markdown: this.state.cguField
    }, {merge: true}).then(() => {
      this.setState({CGUloading: false});
      notification.success({
        message: "Opération réussie"
      })
    })
    .catch((e) => {
      console.error("Error", e);
      notification.error({
        message: "Impossible d'éffectuer l'opération",
        description: e.message
      })
    })
  }

  webookButton(buttonName, link) {
    let loading = false;
    return (<Button
      type="primary"
      loading={this.state[`loading-${link}`]}
      onClick={async _ => {
        this.setState({[`loading-${link}`]: true});
        try {
          const result = await fetch(link);
          console.log(result.ok);
          if (!result.ok)
            alert("Une erreur est survenue.");
        } catch (err) {
          alert("Une erreur est survenue.");
        }
        this.setState({ [`loading-${link}`]: false });
      }}
    >
      {buttonName}
    </Button>);
  }

  render () {
    const zips = this.props.userStore.zip.docs.map((tag, i) => (<Tag key={i} closable onClose={() => this.deleteTag(tag)}>{tag.data.value}</Tag>));

    return (
      <div>
        <div>

          <Divider orientation="left"><h1>Outils de développement</h1></Divider>
          <div>
            Forcer certaines actions:<br /><br />
            {this.webookButton("Paiement mensuel 6:00", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/mango/doMonthlyPay")}
            <br /><br />
            {this.webookButton("Paiement mensuel 18:00", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/mango/doMonthlyPayOut")}
            <br /><br />
            {this.webookButton("Toutes les 30mn, notif RDV + factures", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/CRON")}
            <br /><br />
            {this.webookButton("Traiter les transactions récurrentes", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/checkRecurring")}
            <br /><br />
            {this.webookButton("Facturer les prestations de la semaine", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/mango/doWeeklyPay")}
            <br /><br />
            {this.webookButton("Envoyer les factures hebdomadaires", "https://us-central1-hoomiz-p0llux.cloudfunctions.net/admin/sendRecurringInvoice")}
          </div>

          <Divider orientation="left"><h1>Zones d'intervention</h1></Divider>
          <div>
            <Spin
              spinning={this.props.userStore.zip.fetching}
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
              >

              {
                zips
              }
              <br /><br />
              <Form layout="inline" onSubmit={e => this.handleSubmit(e)}>
                <FormItem label="">
                  <Input
                    value={this.state.zipCodeField || ''}
                    onChange={event => this.setState({zipCodeField: Number(event.target.value) })}
                    />
                </FormItem>
                <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.loading}>
                  Ajouter
                </Button>
              </FormItem>
              </Form>
            </Spin>
          </div>
        </div>
        <br/>

        <div>
          <Divider orientation="left"><h1>FAQ Intervenant</h1></Divider>
            <Spin
              spinning={this.state.nurseFAQloading}
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
              >
            <div>
              <div>

                <Card loading={this.state.nurseFAQloading} title="Prévisualisation">
                  <ReactMarkdown source={this.state.nursefaqField} />

                </Card>
                <br />
              </div>
              <Form onSubmit={e => this.updateNurseFAQ(e)}>
                <FormItem label="">
                  <TextArea
                    value={this.state.nursefaqField || ''}
                    onChange={event => this.setState({nursefaqField: event.target.value })}
                    rows={4}
                    autosize
                    />
                </FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.nurseFAQloading}>
                  Enregistrer
                </Button>
              </Form>
            </div>
          </Spin>
        </div>
        <br />

        <div>
          <Divider orientation="left"><h1>FAQ Client</h1></Divider>
            <Spin
              spinning={this.state.patientFAQloading}
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
              >
            <div>
              <div>

                <Card loading={this.state.patientFAQloading} title="Prévisualisation">
                  <ReactMarkdown source={this.state.patientfaqField} />

                </Card>
                <br />
              </div>
              <Form onSubmit={e => this.updatePatientFAQ(e)}>
                <FormItem label="">
                  <TextArea
                    value={this.state.patientfaqField || ''}
                    onChange={event => this.setState({patientfaqField: event.target.value })}
                    rows={4}
                    autosize
                    />
                </FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.patientFAQloading}>
                  Enregistrer
                </Button>
              </Form>
            </div>
          </Spin>
        </div>
        <br />

        <div>
          <Divider orientation="left"><h1>CGU</h1></Divider>
            <Spin
              spinning={this.state.CGUloading}
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
              >
            <div>
              <div>

                <Card loading={this.state.CGUloading} title="Prévisualisation">
                  <ReactMarkdown source={this.state.cguField} />

                </Card>
                <br />
              </div>
              <Form onSubmit={e => this.updateCGU(e)}>
                <FormItem label="">
                  <TextArea
                    value={this.state.cguField || ''}
                    onChange={event => this.setState({cguField: event.target.value })}
                    rows={4}
                    autosize
                    />
                </FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.CGUloading}>
                  Enregistrer
                </Button>
              </Form>
            </div>
          </Spin>
        </div>

      </div>
    )
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer
)(Settings);



// WEBPACK FOOTER //
// ./src/Settings.js